export default {
    message: "Pozycje wymienione poniżej są niedostępne i zostały usunięte z koszyka. Proszę dokonać różnych wyborów.",
    buttons: {
        ok: "OK"
    }
}